module.exports = __webpack_public_path__ + "static/media/AETUA_logo.a27ecaeb.png";